// [S-709 / E-PERSONA-ADMIN] Read-only step diagram for a workflow-bound
// persona. Deliberately NOT a separate route or an editable workflow
// canvas — both LongFormWorkflowService and ClauseReviewService are
// hand-built, deterministic, server-held state machines (agentRegistry.ts's
// own comment on `longform` says the procedure "does NOT live here"), so
// there's no config-driven dimension to their step ORDER to expose. This is
// purely "let an admin see how the bound persona behaves," embedded in the
// persona's own detail page — see WorkflowStepWire (data/personaConfigQuery).
import type { WorkflowStepWire } from "../../data/personaConfigQuery";

export function WorkflowStepView({
  steps,
}: {
  steps: WorkflowStepWire[];
}): JSX.Element {
  return (
    <div className="pa-workflow">
      {steps.map((step, i) => (
        <div className="pa-workflow__step" key={step.name}>
          <div className="pa-workflow__index">{i + 1}</div>
          <div className="pa-workflow__body">
            <div className="pa-workflow__name">{step.name}</div>
            <div className="pa-workflow__desc">{step.description}</div>
            {step.tool !== null && (
              <code className="pa-workflow__tool">{step.tool}</code>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
